  // ============ MOBILE NAV TOGGLE ============
  (function initMobileNav() {
    const toggle = document.getElementById('nav-toggle');
    const close = document.getElementById('nav-close');
    const links = document.getElementById('nav-links');
    if (!toggle || !close || !links) return;
    const mobile = window.matchMedia('(max-width: 980px)');
    let returnFocus = null;
    let menuNavigation = false;
    const updateCurrent = () => {
      const target = document.body.dataset.activePage || (window.location.pathname === '/' ? 'home' : null);
      document.querySelectorAll('.nav-link[data-page]').forEach(link => {
        if (link.dataset.page === target) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    };
    const openNav = () => {
      if (!mobile.matches) return;
      returnFocus = toggle;
      links.inert = false;
      links.classList.add('is-open');
      document.body.classList.add('nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      links.setAttribute('aria-hidden', 'false');
      const body = links.querySelector('.ekl-menu-body');
      if (body) body.scrollTop = 0;
      close.focus({ preventScroll: true });
    };
    const closeNav = (options = {}) => {
      const wasOpen = links.classList.contains('is-open');
      links.classList.remove('is-open');
      document.body.classList.remove('nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      links.setAttribute('aria-hidden', 'true');
      if (wasOpen && options.restoreFocus !== false && returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
      links.inert = true;
    };
    window.EKLAVIV_CLOSE_NAV = closeNav;
    toggle.setAttribute('aria-expanded', 'false');
    links.setAttribute('aria-hidden', 'true');
    links.inert = true;
    toggle.addEventListener('click', openNav);
    close.addEventListener('click', () => closeNav());
    links.querySelector('[data-menu-backdrop]')?.addEventListener('click', () => closeNav());
    links.addEventListener('click', (e) => {
      if (e.target.closest('a')) {
        menuNavigation = !!e.target.closest('[data-page]');
        closeNav({ restoreFocus: false });
      }
    });
    document.addEventListener('keydown', (e) => {
      if (!links.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeNav(); return; }
      if (e.key !== 'Tab') return;
      const focusable = Array.from(links.querySelectorAll('.ekl-menu-panel a[href], .ekl-menu-panel button:not([disabled])')).filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (!first) return;
      if (e.shiftKey && (document.activeElement === first || !links.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !links.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
    mobile.addEventListener('change', () => closeNav({ restoreFocus: false }));
    window.addEventListener('eklaviv:pagechange', () => {
      updateCurrent();
      if (!menuNavigation) return;
      menuNavigation = false;
      const heading = document.querySelector('.page.active h1, .page.active h2') || document.querySelector('.page.active');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    });
    updateCurrent();
  })();

